import { Divider, Skeleton } from '@heroui/react';
import { NotificationsListEmpty } from '@ui/notifications/notifications-list-empty';

export type NotificationsListItemProps = {
  title?: string;
  description?: string;
  hint?: string;
  isLoading?: boolean;
  isAlert?: boolean;
};

export const NotificationsListItem = ({
  title,
  description,
  hint,
  isAlert = false,
  isLoading = false,
}: NotificationsListItemProps) => {
  return (
    <div className="relative py-4">
      {isAlert && !isLoading && (
        <div className="w-2 h-2 rounded-full bg-[#1A73E8] absolute top-5 right-0" />
      )}

      <Skeleton className="rounded-md" isLoaded={!isLoading}>
        <p className="text-[#222222] font-semibold">{title}</p>
      </Skeleton>

      <Skeleton className="mt-2 lg:mt-3 rounded-md" isLoaded={!isLoading}>
        <p className="text-[#60656C] text-sm">{description}</p>
      </Skeleton>

      <Skeleton className="mt-3 rounded-md" isLoaded={!isLoading}>
        <p className="text-[#9CA5AC] text-xs lg:text-sm">{hint}</p>
      </Skeleton>
    </div>
  );
};

export type NotificationsListProps = {
  items?: (NotificationsListItemProps | undefined)[];
  isDivided?: boolean;
  isShowPlaceholder?: boolean;
};

export const NotificationsList = ({
  items = [],
  isDivided = true,
  isShowPlaceholder = true,
}: NotificationsListProps) => {
  if ((!items || items.length === 0) && isShowPlaceholder) {
    return <NotificationsListEmpty />;
  }
  return (
    <>
      {items?.map((item, index) => {
        return (
          <div key={index}>
            <NotificationsListItem {...item} />
            {isDivided && index + 1 !== items?.length && <Divider />}
          </div>
        );
      })}
    </>
  );
};
